import React from 'react'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import { useLocalization } from '@/hooks/localization'

const WidgetContent = function WidgetContent ({ data }) {
  const { localize } = useLocalization()
  return (
    <div style={{ height: 270 }}>
      <table className='table table-striped messages-widget-table'>
        <thead>
          <tr>
            <td>{localize('Messages.Sender')}</td>
            <td>{localize('Messages.Recipient')}</td>
            <td>{localize('Messages.Subject')}</td>
            <td>{localize('Messages.Sent')}</td>
            <td>{localize('Messages.Read')}</td>
            <td>{localize('Messages.DueDate')}</td>
            <td>{localize('Common.Detail')}</td>
          </tr>
        </thead>
        <tbody>
          {(data || []).map((msg, index) => (<tr key={index}>
            <td>{msg.senderName}</td>
            <td>{msg.recipientName}</td>
            <td>{msg.subject}</td>
            <td>{formatDate(msg.sendingTime, defaultDateTimeFormat)}</td>
            <td>{formatDate(msg.readTime, defaultDateTimeFormat)}</td>
            <td>{formatDate(msg.dueDate)}</td>
            <td><Link to={`/messages/${msg.id}`}><Icon name='show' /></Link></td>
          </tr>))}
        </tbody>
      </table>
    </div>
  )
}

export default WidgetContent



// WEBPACK FOOTER //
// ./src/components/messages/widgetContent.js